import CheckCircleSolidSVG from "@design-system/ui-icons/vanilla/CheckCircleSolid"
import { createIcon } from "../createIcon"

export const CheckCircleSolidIcon = createIcon(CheckCircleSolidSVG)
